module.exports = __webpack_public_path__ + "static/fonts/iconfont.c562bd1.eot";


//////////////////
// WEBPACK FOOTER
// ./src/assets/iconfont_ali/iconfont.eot?t=1582110905786
// module id = 842
// module chunks = 115